<script>
export const group = 'Full'
</script>

<script setup>
import { frames } from '../../../utils/frames.js'
import gsap from 'gsap'
import VideoPlayer from '../../VideoPlayer.vue'
import { onUnmounted } from 'vue'
import JOELogoWhite from '../../../assets/images/joe_logo_white.svg'
import TiktokIcon from '../../../assets/images/tiktok.svg'
import JOEBackground1 from '../../../assets/animations/joe/backgrounds/joe_background_1.webm'
import TextSlideUpFade from './text_animations/TextSlideUpFade.vue'
import Transition4 from './transitions/Transition4.vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const phoneElement = ref(null)
const panesElement = ref(null)
const socialMediaReferencesElements = ref(null)

const timelineTitle = ref(null)

const playoutTweens = []

onMounted(() => {
  const timeline = gsapTimeline({ name: 'Tiktok Feed' })
    .from(phoneElement, { duration: frames(75), scale: 0.75, transformOrigin: 'center bottom', ease: 'power4.inOut' })
    .add(timelineTitle, `=-${frames(45)}`)

  socialMediaReferencesElements.value.forEach((el, i) => {
    timeline.add(
      gsapTimeline()
        .from(el.querySelector('img'), { duration: frames(4), scale: 0, transformOrigin: 'center', ease: 'power2.inOut' })
        .from(el.querySelector('div'), { duration: frames(4), x: 100, opacity: 0, ease: 'power2.inOut' }, `<`),
      `<${frames(8) + i * frames(1)}`
    )
  })

  const paneElements = gsap.utils.toArray(panesElement.value.children).slice(1)
  paneElements.forEach((el, i) => {
    playoutTweens.push(
      gsap.from(el, {
        duration: frames(8),
        yPercent: 100,
        delay: frames(38) + i * 8, // Manual stagger of 8 seconds, with 38-frame offset for the first item
        onStart: () => {
          el.play()
          gsap.to(paneElements[i - 1], { duration: frames(8), yPercent: -100 })
        },
      })
    )
  })
})

onUnmounted(() => {
  playoutTweens.forEach((tl) => tl.kill())
})

const randomlyOrderedFeed = computed(() => {
  if (!item.enrichment.feed) return []

  return [...item.enrichment.feed].sort(() => 0.5 - Math.random())
})
</script>

<template>
  <Transition4>
    <div class="size-full">
      <VideoPlayer :src="JOEBackground1" class="absolute size-full object-cover" autoplay muted loop />

      <div ref="phoneElement" class="absolute w-[581px] h-[1080px] left-[352px] top-[90px]">
        <div class="absolute top-0 left-0 size-full p-5 pb-30">
          <div ref="panesElement" class="relative bg-green-500 size-full border-[24px] border-white rounded-[5rem] overflow-hidden">
            <div class="absolute size-full bg-joe-cr-blue-darker text-5xl flex flex-col items-center justify-center space-y-16">
              <JOELogoWhite class="w-3/5" :fontControlled="false" />
              <div class="flex items-center space-x-4 text-white">
                <div class="rounded-full size-14 bg-joe-cr-blue-primary flex items-center justify-center mt-2">
                  <TiktokIcon class="size-8 fill-current text-joe-cr-blue-darker" :fontControlled="false" />
                </div>
                <span>{{ item.properties.tiktokUsername }}</span>
              </div>
            </div>
            <VideoPlayer v-for="video in randomlyOrderedFeed" :key="video.id" class="absolute size-full object-cover bg-joe-cr-blue-primary" :src="video.url" loop muted />
          </div>
        </div>
      </div>

      <div class="relative ml-[1060px] h-full flex flex-col justify-end w-[750px] pb-32 space-y-12">
        <TextSlideUpFade class="text-white font-bold text-[8rem]" :text="item.properties.title" @timeline="timelineTitle = $event" />
        <div class="space-y-10">
          <div v-for="{ uuid, image, handle } in item.properties.socialMediaReferences" ref="socialMediaReferencesElements" :key="uuid" class="flex items-center space-x-6">
            <img :src="image" class="size-20 mt-2 object-contain" />
            <div class="text-white text-[3.5rem]" v-text="handle" />
          </div>
        </div>
      </div>
    </div>
  </Transition4>
</template>
